import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'antd';
import checkmarkSolidCircle from '../assets/icons/checkmarkSolidCircle.svg'
import { AiOutlineClose } from 'react-icons/ai'
import CloseModal from './CloseModal';


function ConnectionRestoredModal(props) {
    const [show, setShow] = useState(false)

    useEffect(() => {
        setShow(props.show)
    }, [])

    const handleClose = () => {
        props.closeModal()
        setShow(false)
    }

    const connectionRestoredModalContentStyle = {
        display: "flex",
        flexDirection: "row",
        alignSelf: "center"
    }

    const closeButtonStyle = {
        borderColor: "#7BB9D7"
    }

    return(
        <>
            <Modal
                title={props.title}
                centered
                visible={show}
                onCancel={handleClose}
                maskClosable={false}
                footer={[
                    <div className="connection-resotred-button">
                        <Button className="ant-btn-default" style={closeButtonStyle} key="submit" type="primary" onClick={handleClose}>Go back to chat</Button>
                    </div>
                ]}
               closeIcon={<CloseModal />} 
            >

                <div className="connection-restored-close" style={connectionRestoredModalContentStyle}>
                <svg width="40" height="84" viewBox="0 0 40 84" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="19.9997" cy="20.0007" r="16.6667" fill="#57A635"/>
                    <path d="M16.6663 27.5828C16.447 27.5841 16.2295 27.542 16.0265 27.4591C15.8234 27.3762 15.6387 27.254 15.483 27.0995L10.5663 22.0995C10.2547 21.7856 10.0805 21.3609 10.082 20.9186C10.0836 20.4763 10.2608 20.0528 10.5746 19.7411C10.8885 19.4295 11.3133 19.2553 11.7555 19.2569C12.1978 19.2585 12.6213 19.4356 12.933 19.7495L16.6663 23.4495L25.3996 13.1161C25.6847 12.778 26.0925 12.567 26.5332 12.5294C26.9739 12.4919 27.4115 12.631 27.7496 12.9161C28.0878 13.2013 28.2988 13.609 28.3363 14.0497C28.3738 14.4904 28.2347 14.928 27.9496 15.2661L18.033 26.9328C17.882 27.1095 17.6958 27.2527 17.4863 27.3531C17.2768 27.4536 17.0486 27.5091 16.8163 27.5161L16.6663 27.5828Z" fill="white"/>
                </svg>

                    <p class="modal-content-connectionRestored">{props.message}</p>
                </div>
            </Modal>
        </>
    )
}

export default ConnectionRestoredModal